import commonDataAccess from "../commonDataAccess";
import { IListType } from "src/@redux/store";

export interface TastePanel {
  id: number | string;
  sequencePosition?: number | string;
  productId?: number | string;
  organizationId: number;
  isActive?: boolean;
}

export interface TastePanelListItem {
  id: number | string;
  sequencePosition?: number | string;
  productName?: string;
  organizationId: number;
  isActive?: boolean;
}



class TastePanelDataAccess {
  getAllTastePanel = (): Promise<TastePanel[]> => {
    return commonDataAccess.getData("tastepanel/getAll");
  };

  getTastePanelList = (
    params: IListType
  ): Promise<{ data: TastePanelListItem[]; dataCount: number }> => {
    let _filters: Record<string, string> = {};
    params.filters?.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return commonDataAccess.getData("tastepanel/getall", parameters);
  };

  getTastePanelInfo = (
    tastePanelId: number | string
  ): Promise<{ success: boolean; data: TastePanel }> => {
    return commonDataAccess.getData(`tastepanel/get/tastepanelInfo/${tastePanelId}`);
  };

  saveTastePanelInfo = (
    payload: Partial<TastePanel>
  ): Promise<{ success: boolean; data: TastePanel }> => {
    return commonDataAccess.postData("tastepanel/save", payload);
  };

  deleteTastePanelInfo = (
    tastePanelId: number | string
  ): Promise<{ success: boolean; message: string }> => {
    return commonDataAccess
      .deleteData(`tastepanel/${tastePanelId}`)
      .then((res) => ({
        success: res?.success,
        message: res?.message,
      }));
  };

  // getAllTastePanelForDropdown = (): Promise<TastePanel[]> => {
  //   return commonDataAccess.getData("tastepanel/dropdown");
  // };

  deleteTastePanelsBulk = (
    tastePanelIds: (number | string)[]
  ): Promise<{ success: boolean; message: string }> => {
    return commonDataAccess.postData("tastepanel/deleteAll", tastePanelIds);
  };
}

export default new TastePanelDataAccess();